import Autocomplete from "../../library/Autocomplete";
import {TRAFFIC_TYPES_ARRAY} from "../../../utils/misc";
import { isAllowedFilterField } from "../../../utils/UserHelper";
import { IdName } from "../../../utils/types";
import { MenuItem, Option } from "react-bootstrap-typeahead";

function TrafficTypeAutocomplete(props: any) {
  const handleKeepOpenClick = (option: IdName) => {
    const currentSelected = props.selected || [];
    const isSelected = currentSelected.some((selected: IdName) => selected.id === option.id);

    let newSelection;
    if (isSelected) {
      // Remove from selection
      newSelection = currentSelected.filter((selected: IdName) => selected.id !== option.id);
    } else {
      // Check if this is a group option that expands to other options
      if (option.id === "all-mobile") {
        // Remove individual mobile types and add all-mobile
        const withoutMobile = currentSelected.filter((s: IdName) =>
          !["mobile-android", "mobile-ios", "mobile-other"].includes(s.id)
        );
        newSelection = [...withoutMobile, option];
      } else if (option.id === "all-desktop") {
        // Remove individual desktop types and add all-desktop
        const withoutDesktop = currentSelected.filter((s: IdName) =>
          !["desktop-other", "desktop-NoUserAgent"].includes(s.id)
        );
        newSelection = [...withoutDesktop, option];
      } else {
        // Regular option - just add it
        newSelection = [...currentSelected, option];
      }
    }

    props.onChange(newSelection);
  };

  const handleRegularOnChange = (selected: IdName[]) => {
    // Detect if handleKeepOpenClick already handled this (duplicate in selection)
    const selectedIds = selected.map((s: IdName) => s.id);
    const hasDuplicate = selectedIds.length !== new Set(selectedIds).size;

    if (hasDuplicate || (selected.length > 0 && selected[selected.length - 1] &&
        props.selected?.some((s: IdName) => s.id === selected[selected.length - 1].id))) {
      return; // handleKeepOpenClick already handled it
    }

    // Pass through X button removals and clear button
    props.onChange(selected);
  };

  const renderMenuItemChildren = (option: IdName, menuProps: any, index: number) => {
    return (
      <div
        style={{ cursor: "pointer", padding: "0.25rem 1rem" }}
        onClick={(e: any) => {
          e.stopPropagation();
          e.preventDefault();
          handleKeepOpenClick(option);
        }}
      >
        {option.name}
      </div>
    );
  };

  const renderMenuItem = (option: Option, position: number) => {
    return (
      <MenuItem key={position} option={option} position={position}>
        {renderMenuItemChildren(option as IdName, {}, position)}
      </MenuItem>
    );
  };

  const filterBy = function(option: IdName, filterProps: any) {
    // Filter out already selected items
    const isAlreadySelected = filterProps.selected?.some((selected: IdName) => selected.id === option.id);
    if (isAlreadySelected) return false;

    // Get selected IDs
    const selectedIds = (filterProps.selected || []).map((s: IdName) => s.id);

    // Hide "all-mobile" if all mobile types are already selected
    if (option.id === "all-mobile") {
      const allMobileSelected = ["mobile-android", "mobile-ios", "mobile-other"]
        .every(id => selectedIds.includes(id));
      if (allMobileSelected) return false;
    }

    // Hide "all-desktop" if all desktop types are already selected
    if (option.id === "all-desktop") {
      const allDesktopSelected = ["desktop-other", "desktop-NoUserAgent"]
        .every(id => selectedIds.includes(id));
      if (allDesktopSelected) return false;
    }

    return true;
  };

  return (
    <Autocomplete
      id="trafficTypeAutocomplete"
      placeholder="Traffic Type"
      reactKey="trafficTypeAutocomplete"
      labelKey="name"
      onChange={handleRegularOnChange}
      options={TRAFFIC_TYPES_ARRAY}
      selected={props.selected}
      reactRef={props.reactRef}
      disabled={props.disabled}
      useIncludeExclude={isAllowedFilterField("trafficTypesExclude")}
      defaultIncludeExclude={props.defaultIncludeExclude}
      includeExcludeOnChange={props.includeExcludeOnChange}
      filterBy={filterBy}
      renderMenuItem={renderMenuItem}
      renderMenuItemChildren={renderMenuItemChildren}
      multiple
    />
  );
}

export default TrafficTypeAutocomplete;
